<template>

    <div>
        <!-- This example requires Tailwind CSS v2.0+ -->
        <transition
            enter-class="opacity-0"
            enter-active-class="transition-opacity duration-300 ease-out"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-active-class="transition-opacity duration-300 ease-out"
            leave-to-class="opacity-0"
            appear
            v-if="show"
        >
            <div class="fixed inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" style="z-index: 1000;">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-64 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 bg-gray-500 bg-transition-opacity opacity-75" aria-hidden="true"></div>
                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <transition
                        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-active-class="ease-out duration-300"
                        enter-to-class="opacity-100"
                        leave-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        appear
                        v-if="show"
                    >
                        <div class="inline-block align-bottom bg-white dark:bg-slate-800 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6 relative">
                            <div v-if="closable" class="absolute top-0 right-0 pt-2 pr-2">
                                <button v-on:click.prevent="show = false" type="button" class="bg-white rounded-lg text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <span class="sr-only">Close</span>
                                    <svg-icon
                                        url="fas/xmark"
                                        cursor="pointer"
                                        class="w-4 h-4"
                                    />
                                </button>
                            </div>
                            <div>
                                <div
                                    class="mx-auto flex items-center justify-center h-12 w-12 rounded-full"
                                    v-bind:class="{'bg-green-100': level == 'success', 'bg-blue-100': level == 'info' || level == 'question', 'bg-red-100': level == 'error'}"
                                >
                                    <svg-icon
                                        v-if="level == 'success'"
                                        :key="NaN"
                                        url="fas/check"
                                        class="w-6 h-6 text-green-500"
                                    ></svg-icon>

                                    <svg-icon
                                        v-if="level == 'error'"
                                        :key="NaN"
                                        url="far/triangle-exclamation"
                                        class="w-6 h-6 text-red-500"
                                    ></svg-icon>

                                    <svg-icon
                                        v-if="level == 'info'"
                                        :key="NaN"
                                        url="far/circle-info"
                                        class="w-6 h-6 text-blue-500"
                                    ></svg-icon>

                                    <svg-icon
                                        v-if="level == 'question'"
                                        :key="NaN"
                                        url="far/circle-question"
                                        class="w-6 h-6 text-blue-500"
                                    ></svg-icon>
                                </div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <h3 class="text-lg leading-6 font-medium dark:text-slate-200" v-html="headline"></h3>
                                    <div class="mt-2">
                                        <p class="text-sm dark:text-gray-100" v-html="message"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-6 space-y-4">
                                <button
                                    v-on:click.prevent="buttonClick"
                                    type="button"
                                    class="inline-flex justify-center w-full btn btn-primary btn-small"
                                    v-html="button"
                                ></button>

                                <button
                                    v-if="closeButton"
                                    v-on:click.prevent="show = false"
                                    type="button"
                                    class="inline-flex justify-center w-full btn btn-trans-primary btn-small"
                                    v-html="closeButton"
                                ></button>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                show: false,
                closable: false,
                headline: '',
                message: '',
                button: '',
                buttonHref: '',
                buttonEvent: '',
                buttonEventData: {},
                closeButton: '',
                level: 'success'
            };
        },

        computed: {
            ...mapGetters('general', ['popMessage'])
        },

        mounted() {
            if(this.popMessage) {
                this.showPopMessage(this.popMessage);
            }
        },

        watch: {
            popMessage(message) {
                this.showPopMessage(message)
            }
        },

        methods: {
            showPopMessage(message) {
                this.level = message.level ? message.level : 'success';
                this.headline = message.headline;
                this.message = message.message;
                this.button = message.button ? message.button : 'Ok';
                this.buttonHref = message.buttonHref ? message.buttonHref : null;
                this.buttonEvent = message.buttonEvent ? message.buttonEvent : null;
                this.buttonEventData = message.buttonEventData ? message.buttonEventData : {};
                this.closeButton = message.closeButton ? message.closeButton : null;
                this.closable = message.closable ? message.closable : false;
                this.show = true;
            },

            buttonClick() {
                if (this.buttonHref) {
                    window.location.href = this.buttonHref;
                    return;
                }

                if (this.buttonEvent) {
                    Event.fire(this.buttonEvent, this.buttonEventData);
                    this.show = false;
                    return;
                }

                this.show = false;
            }
        }
    }
</script>
